JavascriptRouter.register({ route: ['condominio.condominios.edit', 'condominio.condominios.create', "condominio", "xrayquiz"] }, function () {
    setupStateCitySelect($('#state_id'), $('#city_id'), '/condominio/cities/select_options');
});
